import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SprintsPagination({
	page,
	totalPages,
	total,
	onPageChange,
}: {
	page: number;
	totalPages: number;
	total: number;
	onPageChange: (page: number) => void;
}) {
	return (
		<div className="mt-4 flex flex-wrap items-center justify-between gap-3">
			<p className="text-xs text-muted">
				Page {page} of {totalPages} · {total} sprint{total === 1 ? "" : "s"}
			</p>
			<div className="flex items-center gap-2">
				<Button
					type="button"
					variant="outline"
					size="sm"
					onClick={() => onPageChange(Math.max(page - 1, 1))}
					disabled={page <= 1}
				>
					<ChevronLeft className="h-3.5 w-3.5" />
					Previous
				</Button>
				<Button
					type="button"
					variant="outline"
					size="sm"
					onClick={() => onPageChange(Math.min(page + 1, totalPages))}
					disabled={page >= totalPages}
				>
					Next
					<ChevronRight className="h-3.5 w-3.5" />
				</Button>
			</div>
		</div>
	);
}
